"use strict";

var _interopRequireDefault = require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireDefault(require("react"));
var _classNames = _interopRequireDefault(require("../classNames"));
var _excluded = ["className", "field", "object"];
var _jsxFileName = "/Users/mweeb/Desktop/codings/nq-component/src/InputDate/index.js";
var defaultProps = {
  object: {},
  type: 'date'
};
function InputDate(_ref) {
  var className = _ref.className,
    field = _ref.field,
    object = _ref.object,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  function onInput(e) {
    var value = e.target.value;
    object[field] = value;
  }
  return /*#__PURE__*/_react["default"].createElement("input", Object.assign({
    defaultValue: object[field] && object[field].slice(0, 10),
    className: (0, _classNames["default"])('form-control', className),
    name: field,
    onInput: onInput
  }, props, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 16,
      columnNumber: 9
    }
  }));
}
InputDate.defaultProps = defaultProps;
var _default = InputDate;
exports["default"] = _default;